/**
 * Seção "Vocabulário" em modo edição (Brief 4 · Tela 2 · PR4).
 *
 * Um editor de chips (termos a evitar) sobre o draft do `usePersonaForm`. Editar substitui o
 * objeto `vocabulary` inteiro no draft (R15: o backend grava o objeto completo). Espelha a
 * leitura (SectionVocabularyRead) em estrutura e copy.
 *
 * ## Por que só «a evitar» (06/Ago/2026 — decisão do TL)
 *
 * O editor de **termos preferidos** foi removido junto com a emissão dele no prompt. Motivo
 * medido: a linha «Prefira os termos: …» chegava ao modelo em TODO turno **sem dizer quando se
 * aplica** — era meta, não fronteira. A persona Comercial do `netcomet_demo` listava «ótima
 * escolha»; a IA disse «Ótima escolha!» a um cliente que não havia escolhido nada, e o cliente
 * reclamou disso na conversa. A lista misturava vocabulário (o nome que a casa dá às coisas,
 * cabe sempre) com reação (frase que só cabe depois de um evento).
 *
 * «Evitar» sobreviveu porque é **fronteira**: vale em qualquer momento e cumpre-se sem esforço.
 *
 * O tenant não perde a capacidade de ensinar vocabulário próprio — ela vive nos **exemplos** da
 * persona, onde a palavra aparece junto da situação que a justifica.
 *
 * ⚠️ `vocabulary.preferredTerms` continua no schema e no dado dos tenants (nada foi apagado);
 * só deixou de ser editável e de ser emitido. A depreciação formal da coluna é decisão própria.
 */

import { PersonaChipEditor } from './PersonaChipEditor';

import type { PersonaForm } from '../use-persona-form';

export function SectionVocabularyEdit({ form }: { form: PersonaForm }): JSX.Element {
  const { vocabulary } = form.draft;

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Vocabulário</h2>
      <p className="pe-panel__subtitle">
        Termos que a IA deve evitar. O vocabulário que ela <em>usa</em> vem dos exemplos, onde cada
        palavra aparece junto da situação que a justifica.
      </p>
      <div className="pe-field">
        <span className="pe-field__label">Termos a evitar</span>
        <PersonaChipEditor
          values={vocabulary.avoidedTerms}
          ariaLabel="Adicionar termo a evitar"
          placeholder="ex.: óbvio"
          onChange={(next) => {
            form.set('vocabulary', { ...vocabulary, avoidedTerms: next });
          }}
        />
      </div>
    </section>
  );
}
